import { render, staticRenderFns } from "./AppTableData.vue?vue&type=template&id=41dfc03b&"
import script from "./AppTableData.vue?vue&type=script&lang=js&"
export * from "./AppTableData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports